import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../useAxios"
import { useTranslation } from "react-i18next";
import { App } from "antd";

export const useAddUser = () => {

    const axios = useAxios();
    const queryClient = useQueryClient();
    const {t} = useTranslation();
    const {message} = App.useApp();

    const addUser = async (user: any) => {
        try {
            const { data } = await axios.post(`/api/user`, user);
            return data;
        } catch (error: any) {
            const apiMessage = error?.response?.data?.message ?? error?.response?.data?.Message;
            throw new Error(apiMessage ?? t("messages.error.addUser"));
        }
    }

    return useMutation({
        mutationFn: addUser,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["users"] });
            message.success(t("messages.success.addUser"));
        },
        onError: (error: Error) => {
            message.error(error.message);
        }
    });
}
